import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 txt-md whitespace-nowrap rounded-full cursor-pointer font-medium transition-all disabled:pointer-events-none disabled:bg-grey-100 disabled:text-grey-400 [&_svg]:pointer-events-none shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
  {
    variants: {
      variant: {
        default: 'bg-brand-400 text-white transition-colors ease duration-300 hover:bg-brand-500 active:bg-brand-300',
        secondary:
          'border border-white transition-colors ease duration-300 bg-transparent text-white hover:text-brand-400 hover:border-brand-400',
        tertiary:
          'border border-black transition-colors ease duration-300 bg-transparent text-black hover:text-brand-400 hover:border-brand-400'
      },
      size: {
        default: 'h-10 px-4 py-2.5 has-[>svg]:pl-5',
        sm: 'h-8 gap-1.5 py-1.5 px-2.5',
        lg: 'h-11 px-5 py-3'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
);

function Button({ className, variant, variantReverse, size, asChild = false, ...props }) {
  const Comp = asChild ? Slot : 'button';

  let finalVariant = variant;
  if (variantReverse) {
    if (variant === 'secondary') {
      finalVariant = 'tertiary';
    } else if (variant === 'tertiary') {
      finalVariant = 'secondary';
    }
  }

  return (
    <Comp data-slot="button" className={cn(buttonVariants({ variant: finalVariant, size, className }))} {...props} />
  );
}

export { Button, buttonVariants };
